interface Sources {
  media: string
}

export function sourceMedia(sources: Sources[], selectedMedia: string) {
  return sources?.filter((source: Sources) => {
    return source?.media === selectedMedia
  })
}
